var React = require('react');

function MaterialUi (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Material-UI icon"),React.createElement("path",{"d":"M0 2.475v10.39l3 1.733V7.67l6 3.465 6-3.465v3.465l-6 3.463v3.464l6 3.463 9-5.195V9.402l-3 1.733v3.463l-6 3.464-3-1.732 6-3.465V2.475L9 7.67 0 2.475zm24 0l-3 1.73V7.67l3-1.732V2.474Z","key":1})]);
}

MaterialUi.defaultProps = {"role":"img","viewBox":"0 0 24 24"};

module.exports = MaterialUi;

MaterialUi.default = MaterialUi;
